var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.501 0h-9.002c-4.141 0.001-7.498 3.358-7.499 7.499v8.999c0.001 4.141 3.358 7.498 7.499 7.499h8.999c4.14-0.001 7.497-3.357 7.499-7.497v-9.002c-0.001-4.14-3.357-7.497-7.497-7.499h-0zM21.749 16.501c-0.004 2.897-2.351 5.244-5.248 5.248h-9.002c-2.897-0.004-5.244-2.351-5.248-5.248v-9.002c0.004-2.897 2.351-5.244 5.248-5.248h9c2.898 0.003 5.247 2.351 5.251 5.248v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 5.841c-3.402 0-6.16 2.758-6.16 6.16s2.758 6.16 6.16 6.16c3.402 0 6.16-2.758 6.16-6.16v0c0-3.402-2.758-6.16-6.16-6.16v0zM12.001 15.85c-2.121 0-3.84-1.719-3.84-3.84s1.719-3.84 3.84-3.84c2.121 0 3.84 1.719 3.84 3.84v0c-0.009 2.117-1.723 3.83-3.839 3.84h-0.001z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.258 5.563c0 0.453-0.367 0.821-0.821 0.821s-0.821-0.367-0.821-0.821c0-0.453 0.367-0.821 0.821-0.821s0.821 0.367 0.821 0.821z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.a7942fa5.svg";
export { ForwardRef as ReactComponent };